export const LOAD_GENERICFILTERPARAMS_STARTED = "LOAD_GENERICFILTERPARAMS_STARTED";
export const LOAD_GENERICFILTERPARAMS_SUCCEEDED = "LOAD_GENERICFILTERPARAMS_SUCCEEDED";
export const LOAD_GENERICFILTERPARAMS_FAILED = "LOAD_GENERICFILTERPARAMS_FAILED";

export const LOAD_GENERICFILTEROPERATORS_STARTED = "LOAD_GENERICFILTEROPERATORS_STARTED";
export const LOAD_GENERICFILTEROPERATORS_SUCCEEDED = "LOAD_GENERICFILTEROPERATORS_SUCCEEDED";
export const LOAD_GENERICFILTEROPERATORS_FAILED = "LOAD_GENERICFILTEROPERATORS_FAILED";

export const LOAD_GENERICFILTERPARAMVALUES_STARTED = "LOAD_GENERICFILTERPARAMVALUES_STARTED";
export const LOAD_GENERICFILTERPARAMVALUES_SUCCEEDED = "LOAD_GENERICFILTERPARAMVALUES_SUCCEEDED";
export const LOAD_GENERICFILTERPARAMVALUES_FAILED = "LOAD_GENERICFILTERPARAMVALUES_FAILED";
